<template>
    <b-badge pill :variant="labelClass"> {{ statoLabel }} </b-badge>
</template>

<script>
export default {
    props: {
        statoLabel: String,
    },

    computed: {
        labelClass() {
            switch (this.statoLabel) {
                case "OCCUPATO":
                    return "warning";
                case "DISPONIBILE":
                    return "success";
                case "SOSPESO":
                    return "danger";
                case "LIBERO":
                    return "primary";
                default:
                    return "secondary";
            }
        },
    },
};
</script>
